<template>
  <section class="content">
    <section class="header">
      <h1>
        Performances <span class="red">Sept 23, 24, 26</span> and
        <span class="red">Oct 1 and 3</span>
      </h1>
      <!-- <h1>
        This play will be performed in different locations. <br />Each date/venue is its own performance. <br />All
        shows at 19:00
      </h1>
      <h1>
        Ticket information
        <span class="red">coming soon</span>
      </h1> -->
    </section>

    <section class="tickets">
      <Venue v-for="show in shows" :key="show.id" :show="show" />
    </section>

    <section class="footer-section">
      <p class="footer-link-info">This production is brought to you by BATS Theatre</p>
      <a class="bats-link" target="_blank" rel="noopener" href="http://www.bats.no">
        For more information go to www.bats.no
      </a>
    </section>
  </section>
</template>

<script>
import Venue from "./Venue";

export default {
  name: 'Content',
  components: {
    Venue,
  },
  data() {
    return {
      shows: [
        {
          id: 'spor5',
          month: 'September',
          date: '23rd 19:00',
          venue: 'Spor 5',
          ticketUrl: 'https://fb.me/e/1FaTjHavc',
          venueImage: 'https://spor5.no/wp-content/uploads/sites/3/2020/02/spor5_frontpage_image_1.jpg',
        },
        {
          id: 'irishman',
          month: 'September',
          date: '24th 19:00',
          venue: 'Irishman',
          ticketUrl: 'https://fb.me/e/dQazh4j6h',
          venueImage: 'https://www.theirishman.no/wp-content/uploads/2015/03/the-bar-the-irishman-stavanger.jpg',
        },
        {
          id: 'paafyll',
          month: 'September',
          date: '26th 19:00',
          venue: 'Påfyll',
          ticketUrl: 'https://fb.me/e/1jPEhLWp6',
          venueImage: 'https://static.wixstatic.com/media/023f4d_8ee7464c7a4945a588e300aa7289121a~mv2.png/v1/crop/x_0,y_0,w_800,h_560/fill/w_259,h_181,al_c,q_85,usm_0.66_1.00_0.01/023f4d_8ee7464c7a4945a588e300aa7289121a~mv2.webp',
        },
        {
          id: 'folken',
          month: 'October',
          date: '1st 19:00',
          venue: 'Folken',
          ticketUrl: 'https://fb.me/e/1vrmIBAMn',
          venueImage: 'https://www.folken.no/folken/wp-content/uploads/2017/07/banner.jpg',
        },
        {
          id: 'stavangeren',
          month: 'October',
          date: '3rd 19:00',
          venue: 'Stavangeren',
          ticketUrl: 'https://fb.me/e/2ju81Zwm7',
          venueImage: 'https://www.stavangeren.no/wp-content/themes/stavangeren/assets/img/logo-inverted.png',
        },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.red {
  font-weight: bold;
  color: #ef4037;
}

.header h1 {
  font-size: 40px;
  font-weight: 400;
  text-align: center;
}

.tickets {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 100px;
  margin-bottom: 100px;
}

.footer-section {
  margin-bottom: 100px;
}

.footer-link-info {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.2em;
  color: #444444;
}

.bats-link {
  border-bottom: 2px #ef4037 solid;
}

@media screen and (min-width: 1700px) {
  .tickets {
    flex-wrap: wrap;
  }
}

@media screen and (min-width: 768px) {
  .content {
    padding: 40px;
  }
  .header {
    text-align: left;
  }
  .tickets {
    flex-direction: row;
  }
}
</style>
